import React from 'react';
const SvgNwcThumbnail = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg width="1em" height="1em" viewBox="0 0 100 100" {...props}>
      <defs>
        <path
          d="M28.306 74.264h2.024v15.4h-2.684l-6.622-12.562v12.562H19v-15.4h2.728l6.578 12.496V74.264zm17.9 0h2.222l-2.728 15.4h-3.212L39.54 76.266l-2.904 13.398h-3.234l-2.75-15.4h2.31l2.178 13.552 2.992-13.552h2.926l3.036 13.552 2.112-13.552zm7.714 15.664c-3.784 0-5.896-2.31-5.896-5.742v-4.07c0-3.762 2.266-6.116 6.006-6.116 2.112 0 3.454.726 4.576 1.65l-1.166 1.32c-.88-.638-1.848-1.188-3.344-1.188-2.464 0-3.828 1.584-3.828 4.29v4.048c0 2.574 1.232 4.026 3.674 4.026 1.584 0 2.662-.572 3.542-1.144l.968 1.386a7.406 7.406 0 01-4.532 1.54z"
          id="nwc-thumbnail_svg__a"
        />
        <path id="nwc-thumbnail_svg__s" d="M.536.118h5.695V32.9H.536z" />
        <path
          d="M.408 5.66C.31 11.596.705 23.86 1.89 33.554l2.072-2.178s.047-11.166.06-13.856c.03-7.382 3.167-3.038 4.179-1.796.776.95 14.262 17.632 14.262 17.632.356.191-11.004-22.779-14.738-28.585C5.737 1.675 4.082.34 2.853.34 1.334.34.463 2.38.408 5.66"
          id="nwc-thumbnail_svg__p"
        />
        <path
          d="M.536.119c1.45 15.203 4.538 30.268 9.198 45.199-1.186-9.694-1.581-21.958-1.483-27.893.099-5.934 2.868-7.813 7.319-.89 3.704 5.76 14.912 28.41 14.744 28.585l9.512.198h.001L32.482 34.93 9.438.216.536.118z"
          id="nwc-thumbnail_svg__e"
        />
        <path
          d="M.615.217L23.659 34.93c1.189-2.244-.234-5.888-4.352-10.978C16.75 23.4 8.507 11.455.615.217z"
          id="nwc-thumbnail_svg__n"
        />
        <path
          d="M.925.74c3.589 17.797 5.86 32.692 2.146 34.191l7.345 10.387-.1-44.508L.926.74z"
          id="nwc-thumbnail_svg__h"
        />
        <path
          d="M.635 45.12l9.095.198.004-.001C5.073 30.385 1.985 15.32.536.117l.1 45.003z"
          id="nwc-thumbnail_svg__b"
        />
        <path
          d="M1.51 4.232c.259 10.52.423 19.904-.83 19.72 4.117 5.091 5.54 8.735 4.351 10.98C8.745 33.431 6.475 18.536 2.885.74L1.511 4.232z"
          id="nwc-thumbnail_svg__k"
        />
        <linearGradient x1="0%" y1="-18.693%" x2="100%" y2="114.705%" id="nwc-thumbnail_svg__f">
          <stop stopColor="#749BCB" offset="0%" />
          <stop stopColor="#4779B9" offset="100%" />
        </linearGradient>
        <linearGradient x1="0%" y1="-16.262%" x2="100%" y2="135.003%" id="nwc-thumbnail_svg__q">
          <stop stopColor="#0C2C54" offset="0%" />
          <stop stopColor="#4779B9" offset="70.757%" />
          <stop stopColor="#749BCB" offset="100%" />
        </linearGradient>
        <linearGradient x1="62.783%" y1="90.887%" x2="50%" y2="0%" id="nwc-thumbnail_svg__i">
          <stop stopColor="#20508D" offset="0%" />
          <stop stopColor="#4779B9" offset="59.285%" />
          <stop stopColor="#749BCB" offset="100%" />
        </linearGradient>
        <radialGradient
          cx="175.147%"
          cy="6.225%"
          fx="175.147%"
          fy="6.225%"
          r="249.48%"
          gradientTransform="matrix(.9266 .06878 -.86758 .391 .183 -.083)"
          id="nwc-thumbnail_svg__l"
        >
          <stop stopColor="#0B2B54" offset="0%" />
          <stop stopColor="#4679B8" offset="100%" />
        </radialGradient>
        <radialGradient
          cx="64.359%"
          cy="63.97%"
          fx="64.359%"
          fy="63.97%"
          r="118.659%"
          gradientTransform="matrix(-.96827 .05085 -.73055 -.57604 1.734 .975)"
          id="nwc-thumbnail_svg__c"
        >
          <stop stopColor="#1F508C" offset="0%" />
          <stop stopColor="#4679B8" offset="100%" />
        </radialGradient>
      </defs>
      <g fill="none" fillRule="evenodd">
        <path d="M4 2v20h24V8h-6V2z" fill="#FFF" />
        <path fill="#6B94C8" d="M11 3v94h78V23H69V3z" />
        <path fill="#FFF" d="M15 8h54v15h16v50H15z" />
        <path fill="#A1C4EE" d="M69 3l20 20H69z" />
        <path fill="#1B3F63" opacity={0.2} d="M69 23h20v20z" />
        <g transform="translate(11 3)">
          <use fill="#000" xlinkHref="#nwc-thumbnail_svg__a" />
          <use fill="#FFF" xlinkHref="#nwc-thumbnail_svg__a" />
        </g>
        <g>
          <path
            d="M29.814 64.588l-.098-44.647 8.629.096 1.344 1.916c7.679 10.946 14.93 21.284 17.404 21.818l.007.001.005.001c.021.002.041.004.062.004a.457.457 0 00.33-.15c.497-.51.747-2.559.809-6.643.055-3.602-.051-8.433-.164-13.076l1.316-3.345 9.092.067.098 44.148-9.255-.192c-.92-1.137-13.467-16.657-14.209-17.568a13.63 13.63 0 01-.181-.225c-.67-.838-1.793-2.241-2.77-2.241-1.027 0-1.533 1.43-1.547 4.374l-.059 13.788-1.967 2.067-8.846-.193z"
            fill="#4779B9"
          />
          <g transform="translate(29 19.644)">
            <mask id="nwc-thumbnail_svg__d" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__b" />
            </mask>
            <path
              d="M.635 45.12l9.095.198.004-.001C5.073 30.385 1.985 15.32.536.117l.1 45.003z"
              fill="url(#nwc-thumbnail_svg__c)"
              mask="url(#nwc-thumbnail_svg__d)"
            />
          </g>
          <g transform="translate(29 19.644)">
            <mask id="nwc-thumbnail_svg__g" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__e" />
            </mask>
            <path
              d="M.536.119c1.45 15.203 4.538 30.268 9.198 45.199-1.186-9.694-1.581-21.958-1.483-27.893.099-5.934 2.868-7.813 7.319-.89 3.704 5.76 14.912 28.41 14.744 28.585l9.512.198h.001L32.482 34.93 9.438.216.536.118z"
              fill="url(#nwc-thumbnail_svg__f)"
              mask="url(#nwc-thumbnail_svg__g)"
            />
          </g>
          <g transform="translate(58.412 19.644)">
            <mask id="nwc-thumbnail_svg__j" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__h" />
            </mask>
            <path
              d="M.925.74c3.589 17.797 5.86 32.692 2.146 34.191l7.345 10.387-.1-44.508L.926.74z"
              fill="url(#nwc-thumbnail_svg__i)"
              mask="url(#nwc-thumbnail_svg__j)"
            />
          </g>
          <g transform="translate(56.451 19.644)">
            <mask id="nwc-thumbnail_svg__m" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__k" />
            </mask>
            <path
              d="M1.51 4.232c.259 10.52.423 19.904-.83 19.72 4.117 5.091 5.54 8.735 4.351 10.98C8.745 33.431 6.475 18.536 2.885.74L1.511 4.232z"
              fill="url(#nwc-thumbnail_svg__l)"
              mask="url(#nwc-thumbnail_svg__m)"
            />
          </g>
          <g transform="translate(37.824 19.644)">
            <mask id="nwc-thumbnail_svg__o" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__n" />
            </mask>
            <path
              d="M.615.217L23.659 34.93c1.189-2.244-.234-5.888-4.352-10.978C16.75 23.4 8.507 11.455.615.217z"
              mask="url(#nwc-thumbnail_svg__o)"
            />
          </g>
          <g transform="translate(36.843 31.408)">
            <mask id="nwc-thumbnail_svg__r" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__p" />
            </mask>
            <path
              d="M.408 5.66C.31 11.596.705 23.86 1.89 33.554l2.072-2.178s.047-11.166.06-13.856c.03-7.382 3.167-3.038 4.179-1.796.776.95 14.262 17.632 14.262 17.632.356.191-11.004-22.779-14.738-28.585C5.737 1.675 4.082.34 2.853.34 1.334.34.463 2.38.408 5.66"
              fill="url(#nwc-thumbnail_svg__q)"
              mask="url(#nwc-thumbnail_svg__r)"
            />
          </g>
          <path
            d="M38.439 19.86l.851 1.25.849 1.254 1.696 2.504 3.375 5.024.843 1.257.84 1.259 1.677 2.516 3.355 5.038 3.337 5.048 1.669 2.524 1.66 2.53 1.66 2.53.83 1.266.413.633c.14.21.287.416.429.623 1.146 1.66 2.296 3.318 3.437 4.98-1.177-1.637-2.346-3.282-3.518-4.924-.146-.206-.295-.41-.439-.616l-.422-.628-.844-1.256-1.688-2.511-1.687-2.512-1.677-2.519-3.357-5.035-3.34-5.048-1.668-2.524-.835-1.262-.83-1.265-3.32-5.06-1.65-2.537-.826-1.269-.82-1.27z"
            fill="#A3BCDC"
          />
          <g transform="translate(29 19.644)">
            <mask id="nwc-thumbnail_svg__t" fill="#fff">
              <use xlinkHref="#nwc-thumbnail_svg__s" />
            </mask>
            <path
              d="M.536.117L.66 1.152l.117 1.033.254 2.067.264 2.063.285 2.062a264.3 264.3 0 001.298 8.22l.363 2.049.384 2.045.397 2.042.412 2.04.427 2.037.446 2.033.456 2.03.236 1.014.233 1.014-.268-1.005-.263-1.007-.508-2.02-.48-2.026-.459-2.033c-.149-.677-.294-1.355-.438-2.035L3.4 20.734l-.39-2.046-.37-2.05-.345-2.054-.323-2.058-.3-2.06c-.095-.688-.186-1.377-.276-2.065l-.252-2.067-.231-2.07-.201-2.072-.09-1.036L.536.117z"
              fill="#A3BCDC"
              mask="url(#nwc-thumbnail_svg__t)"
            />
          </g>
          <path
            d="M61.483 54.575c.167-.075.323-.171.46-.292.134-.122.26-.256.36-.408.21-.297.36-.631.478-.975.118-.345.204-.7.27-1.057.066-.358.114-.72.15-1.082.145-1.451.121-2.915.049-4.373a75.811 75.811 0 00-.372-4.366c-.16-1.45-.35-2.9-.56-4.347a201.85 201.85 0 00-.671-4.333c-.234-1.444-.488-2.884-.736-4.324-.252-1.442-.513-2.88-.78-4.32l-.794-4.315.233 1.073.228 1.072.449 2.15c.289 1.434.571 2.869.845 4.305.546 2.876 1.04 5.761 1.462 8.66.206 1.447.395 2.9.549 4.356.15 1.456.277 2.917.329 4.381.027.733.038 1.466.025 2.2a22.844 22.844 0 01-.139 2.194c-.046.364-.104.727-.18 1.086a7.23 7.23 0 01-.298 1.061c-.127.345-.287.68-.508.976a2.25 2.25 0 01-.377.4 1.888 1.888 0 01-.472.278M54.379 54.432l-1.54-2.972c-.513-.991-1.03-1.98-1.55-2.967a430.8 430.8 0 00-3.14-5.91c-1.073-1.956-2.135-3.92-3.297-5.819-.584-.946-1.213-1.867-1.924-2.717a10.714 10.714 0 00-1.15-1.188 6.031 6.031 0 00-.652-.498 3.397 3.397 0 00-.718-.366 1.898 1.898 0 00-.772-.125 1.41 1.41 0 00-.722.252c-.109.072-.207.16-.297.257a2.33 2.33 0 00-.249.312 3.764 3.764 0 00-.373.72 7.562 7.562 0 00-.42 1.59 13.858 13.858 0 00-.159 1.651c-.058 2.225-.022 4.46.011 6.689.041 2.23.11 4.46.207 6.689a240.787 240.787 0 00.156 3.343c.059 1.115.125 2.227.194 3.341l-.136-1.668c-.042-.555-.085-1.112-.12-1.67a242.343 242.343 0 01-.21-3.341c-.122-2.229-.212-4.46-.275-6.69a158.856 158.856 0 01-.061-5.861c.003-.279.005-.558.017-.84.02-.561.068-1.122.156-1.678a7.81 7.81 0 01.427-1.641 4.03 4.03 0 01.395-.764c.08-.12.169-.236.27-.342a1.841 1.841 0 01.732-.495c.142-.051.291-.08.44-.09.15-.01.3-.003.445.023.145.025.289.061.425.113.274.097.528.237.766.394.24.156.463.332.677.519.426.373.809.788 1.17 1.218.72.865 1.35 1.795 1.934 2.748a87.3 87.3 0 011.678 2.902c.544.975 1.072 1.96 1.595 2.944a410.755 410.755 0 013.085 5.945 567.81 567.81 0 011.502 2.99l.746 1.5.737 1.502z"
            fill="#A3BCDC"
          />
        </g>
      </g>
    </svg>
  );
});
export default SvgNwcThumbnail;
SvgNwcThumbnail.iconName = 'nwc-thumbnail';
SvgNwcThumbnail.displayName = 'SvgNwcThumbnail';
